import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.REPORTS,
    loadComponent: () =>
      import('./reports.component').then((m) => m.ReportsComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.REPORTS,
    loadComponent: () =>
      import('./reports.component').then((m) => m.ReportsComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportsModule {}
